import DOMPurify from 'dompurify';

// Hosts confiáveis de vídeo/embed que podem aparecer em <iframe> no conteúdo do CMS
// (ex.: `additional_info` de conteúdos — vídeos VERTICAIS vêm embutidos como iframe do
// Panda — e o HTML dos templates de venda). Sem isto, o DOMPurify remove o <iframe> e o
// vídeo some.
const TRUSTED_IFRAME_HOSTS =
  /(^|\.)(pandavideo\.com\.br|mediadelivery\.net|b-cdn\.net|youtube\.com|youtube-nocookie\.com|youtu\.be|vimeo\.com)$/i;

let hookAdded = false;
function ensureHook() {
  if (hookAdded || typeof window === 'undefined') return;
  hookAdded = true;
  // Remove qualquer <iframe> cujo host NÃO seja de vídeo confiável (defesa contra XSS).
  DOMPurify.addHook('uponSanitizeElement', (node, data) => {
    if (data.tagName !== 'iframe') return;
    const src = (node.getAttribute && node.getAttribute('src')) || '';
    let ok = false;
    try {
      ok = TRUSTED_IFRAME_HOSTS.test(new URL(src, window.location.origin).hostname);
    } catch (e) {
      ok = false;
    }
    if (!ok && node.parentNode) node.parentNode.removeChild(node);
  });
}

const RICH_ATTR = [
  'allow', 'allowfullscreen', 'frameborder', 'scrolling', 'src',
  'width', 'height', 'style', 'id', 'fetchpriority', 'title', 'target',
];

// Sanitiza HTML vindo do CMS PERMITINDO <iframe> apenas de hosts de vídeo confiáveis.
export function sanitizeRichHtml(html) {
  ensureHook();
  return DOMPurify.sanitize(html || '', { ADD_TAGS: ['iframe'], ADD_ATTR: RICH_ATTR });
}

// Para conteúdo do CMS que traz o PRÓPRIO <style> (ex.: o quiz em CSS puro embaixo do
// vídeo, que usa `input:checked ~ .resposta` pra revelar a resposta). O DOMPurify
// SEMPRE remove o <style>, o que quebra o quiz (mostra todas as respostas de cara).
// Este helper é usado dentro de um <iframe sandbox> (ver AdditionalInfoFrame), que
// ISOLA o CSS (o `html,body{}` do quiz não vaza pra página) e BLOQUEIA scripts — então
// dá pra preservar o <style> com segurança: extraímos os <style>, sanitizamos o resto
// do HTML normalmente, e recolocamos os <style> na frente.
export function sanitizeForFrame(html) {
  ensureHook();
  const input = html || '';
  const styles = [];
  const body = input.replace(/<style[\s\S]*?<\/style>/gi, (m) => {
    styles.push(m);
    return '';
  });
  const clean = DOMPurify.sanitize(body, { ADD_TAGS: ['iframe'], ADD_ATTR: RICH_ATTR });
  return styles.join('\n') + clean;
}
